import type { MenuItem } from "../types/navigation";

export const getDefaultMenuItems = (): MenuItem[] => [
  {
    name: "Accueil",
    key: "accueil",
    href: "/",
    onClick: () => {
      if (window.location.pathname === "/") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
  },
  { name: "Hôpitaux", key: "hopitaux", href: "/etablissement/connexion" },
  { name: "Maps", key: "maps", href: "/medical-maps" },
  { name: "Professionnels", key: "professionnels", href: "/professionnel/connexion" },
  { name: "Patients", key: "patients", href: "/patient/connexion" },
];
